<template>
  <v-menu
    v-model="dateMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        clearable
        :outlined="outlined"
        v-model="data"
        :label="label"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="data" @input="dateMenu = false"></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      default: ''
    },
    label: {
      default: 'Date'
    },
    outlined: {
      default: false
    }
  },
  data() {
    return {
      dateMenu: false,
      data: ''
    }
  },

  created() {
    if (this.value) {
      this.data = this.value
    }
  },
  watch: {
    data: function(value) {
      this.$emit('input', value)
    },
    value: function(value) {
      this.data = value
    }
  }
}
</script>

<style></style>
